import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {TextUtils} from "../../../../../shared/utils/text-utils";
import {Website} from "../../../website";
import {filter, first} from "rxjs/operators";
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import * as fromStore from "../../../../../store";
import {EcommerceService} from "../../ecommerce.service";
import {Store} from "@ngrx/store";
import {FormControl} from "@angular/forms";
import {DbModalService} from "../../../../../modules/modal/modal";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {SuccessfulPopupComponent} from "../../dialogs/success/successful-popup.component";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";


@Component({
    selector: 'db-enable-tax-calc',
    templateUrl: './enable-tax-calc.component.html',
    styleUrls: ['./enable-tax-calc.component.scss'],
    standalone: false
})
export class EnableTaxCalcComponent implements OnInit, OnDestroy {

  @Input() website: Website;
  public searchTerm: FormControl = new FormControl();
  public fakeOptions = [
    {value: null, label: TextUtils.getText('text_live')},
    {value: null, label: TextUtils.getText('text_staging')}
  ];
  public fakeAddRatesOptions = [
    {value: null, label: TextUtils.getText('text_live')},
    {value: null, label: TextUtils.getText('text_staging')}
  ];
  public loading: boolean = false;
  public loadingScreen: boolean = false;

  constructor(
    private readonly _store: Store<fromStore.DbStoreState>,
    private _modalService: DbModalService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _ecommerceService: EcommerceService
  ) {
  }

  ngOnInit() {
  }

  public enableCalcTaxes(): void {
    this.loading = true;
    this._ecommerceService.enableCalcTaxes(this.website?.id, true)
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response: DbResponse): void => {
        this.loadingScreen = true;
        if (response.success && response?.data) {
          this.showActivationModal();
          this.loadingScreen = true;
          this._store.dispatch(new fromStore.LoadEcommerceGeneralSettings({websiteId: this.website?.id}));
          this._store.dispatch(new fromStore.LoadEcommerceTaxSettings({websiteId: this.website?.id}));
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
          this.loading = false;
        }
      });
  }

  private _sendEvent(label): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: 'Ecommerce - Tax',
      eventLabel: label
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  private showActivationModal() {
    if (!this._modalService.hasOpenModals()) {
      const modal = this._modalService.open(SuccessfulPopupComponent, {width: 700});
      modal.componentInstance.title = TextUtils.getText('text_successfullyActivatedTaxCalculation');
      modal.componentInstance.description = TextUtils.getText('text_youCanStartChargingTax');
    }
  }

  ngOnDestroy() {

  }
}
